/**
 * Used to merge two refs, e.g., allow a local component ref, as well as a forwarded ref, to access the same DOM element
 * See https://github.com/gregberge/react-merge-refs
 */
export function mergeRefs<T>(
  refs: Array<React.MutableRefObject<T> | React.LegacyRef<T>>
): React.RefCallback<T> {
  return (value) =>
    refs.forEach((ref) => {
      if (typeof ref === 'function') {
        ref(value);
      } else if (ref != null) {
        (ref as React.MutableRefObject<T | null>).current = value;
      }
    });
}
